import { useState } from "react";
import { UsersApi, UsersLogoutPostRequest } from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiLogout = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const cleanup = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("loginHistoryId");
    localStorage.removeItem("user");
    localStorage.removeItem("isAuthenticated");
  };

  const logout = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const idStr = localStorage.getItem("loginHistoryId");
      const id = idStr ? Number(idStr) : NaN;

      const config = createConfiguration();
      const api = new UsersApi(config);

      if (idStr && !Number.isNaN(id)) {
        const request: UsersLogoutPostRequest = {
          req: { loginHistoryId: id },
        };
        await api.usersLogoutPost(request);
      }

      cleanup();
      return true;
    } catch (e) {
      console.error("Logout error:", e);
      setError("logout_failed");
      cleanup();
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { logout, isLoading, error };
};
